import { render, staticRenderFns } from "./app-empty-layout.vue?vue&type=template&id=534590b0&scoped=true&"
import script from "./app-empty-layout.vue?vue&type=script&lang=js&"
export * from "./app-empty-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534590b0",
  null
  
)

export default component.exports